module.exports = __webpack_public_path__ + "static/bottlebooks_logo_white-8a96912a246d37a948c7f17137613015.svg";